export const fontFamiliy = {
  first: "Kumbh Sans",
  second: "Roboto Slab",
  third: "Space Mono",
};

export const fontWeights = {
  first: 700,
  second: 400,
  third: 700,
};
